import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { ProductDetailsDto } from '../dtos';

@Injectable()
export class ProductService {
  private path = 'product';
  constructor(private httpService: HttpService) {}

  public getProductDetails(barcode: string, priceLevel: number): Observable<ProductDetailsDto> {
    return this.httpService.makeGet<ProductDetailsDto>(`${this.path}/${barcode}/${priceLevel}`);
  }
}
